const clusterColumns = [
  { Header: 'Npod', accessor: 'name' },
  { Header: 'Size raw TB', accessor: 'raw_tb' },
  { Header: 'Usable TB', accessor: 'useable_tb' },
  { Header: 'Consumed TB', accessor: 'consumed_tb' },
  { Header: 'Free TB', accessor: 'free_tb' },
  { Header: '% Used', accessor: 'used_percent', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false },
  { Header: '% Free', accessor: 'free_percent', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false }
]

const clusterChartColumns = [
  { label: 'Size raw TB', accessor: 'raw_tb' },
  { label: 'Usable TB', accessor: 'useable_tb' },
  { label: 'Consumed TB', accessor: 'consumed_tb' },
  { label: 'Free TB', accessor: 'free_tb' },
  { label: '% Used', accessor: 'used_percent' },
  { label: '% Free', accessor: 'free_percent' }
]

const spuColumns = [
  { Header: 'Host', accessor: 'name' },
  { Header: 'Usable TB', accessor: 'usable_tb' },
  { Header: 'Consumed TB', accessor: 'consumed_tb' },
  { Header: 'Free TB', accessor: 'free_tb' },
  { Header: '% Used', accessor: 'used_percent', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false },
  { Header: '% Free', accessor: 'free_percent', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false }
]

const spuChartColumns = [
  { label: 'Usable TB', accessor: 'usable_tb' },
  { label: 'Consumed TB', accessor: 'consumed_tb' },
  { label: 'Free TB', accessor: 'free_tb' },
  { label: '% Used', accessor: 'used_percent' },
  { label: '% Free', accessor: 'free_percent' }
]

const volumeColumns = [
  { Header: 'SPU', accessor: 'spu' },
  { Header: 'SPU Serial', accessor: 'serial' },
  { Header: 'Volume', accessor: 'name' },
  { Header: 'Size TB', accessor: 'size_tb' },
  { Header: 'Used TB', accessor: 'written_tb' },
  { Header: 'Free TB', accessor: 'free_tb' },
  { Header: '% Used', accessor: 'used_percent', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false },
  { Header: '% Free', accessor: 'free_percent', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false }
]

const volumeChartColumns = [
  { label: 'Size TB', accessor: 'size_tb' },
  { label: 'Used TB', accessor: 'written_tb' },
  { label: 'Free TB', accessor: 'free_tb' },
  { label: '% Used', accessor: 'used_percent' },
  { label: '% Free', accessor: 'free_percent' }
]

export { clusterColumns, clusterChartColumns, spuColumns, spuChartColumns, volumeColumns, volumeChartColumns }